// Accessible names. Frames carry no user-facing name of their own, so the chain sequence number is
// the only identity available — included whenever the frame has one. The instruction rides in the
// label rather than a separate description, matching this codebase's other keyboard affordances
// (see `photo-tray-thumbnail.tsx`). Strings are inline English: there is no i18n layer in this app.
function framePrefix(seq: number | undefined): string {
  return seq != null ? `Text frame ${seq}. ` : ''
}

export function startLinkLabel(seq: number | undefined): string {
  return `${framePrefix(seq)}Start a text link from this text frame. Press Enter to begin, then choose a frame to link to.`
}

export function unlinkLabel(seq: number | undefined): string {
  return `${framePrefix(seq)}Break the text link from this text frame to the next frame. Press Enter to unlink.`
}

export function lockedLinkLabel(seq: number | undefined): string {
  return `${framePrefix(seq)}Text link unavailable. This text frame is locked; unlock it to change its links.`
}

export function linkTargetLabel(seq: number | undefined): string {
  return `${framePrefix(seq)}Link text into this text frame. Press Enter to link.`
}
